module.exports = __webpack_public_path__ + "static/media/Televida-logo.c93cd54e.svg";